import { Component, EventEmitter, Input, Output } from '@angular/core';

// Area analysis modal shown when a geo fence is clicked on the map.
@Component({
  selector: 'geo-fence-analysis-modal',
  templateUrl: './geo-fence-analysis-modal.component.html',
})
export class GeoFenceAnalysisModalComponent {
  @Input() deviceInfo: boolean = false;
  @Input() access: any;

  @Output() moveInAreaClicked = new EventEmitter<void>();
}
